<div class="links">
    <div></div>
    <span>Or</span>
    <div></div>
</div>